import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, FieldArray } from 'redux-form';
import { TextField, SelectField, RadioButtonGroup } from 'redux-form-material-ui';
import { RadioButton } from 'material-ui/RadioButton';
import MenuItem from 'material-ui/MenuItem';

import { CSSTransitionGroup } from 'react-transition-group';

import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import FlatButton from 'material-ui/FlatButton';

import validate from '../validate';
import { RenderError } from 'components/shared/RenderError';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

import { RenderGhostError } from 'components/shared/RenderError';

import scrollIntoView from 'scroll-into-view';

import { getTranslatedString } from 'helpers/i18n';
import { VEHICLE_TYPES } from 'constants/vehicleTypes.constants';

const style = {
  button: {
    color: 'white',
    float: 'right',
    height: '40px',
  },
  backButton: {
    float: 'left',
    color: AccentColor(),
    height: '40px',
  },
  add_vehicle_button: {
    color: 'white',
  },
};

const renderVehicles = ({ fields, meta: { touched, error, submitFailed } }) => (
  <div className="row">
    <CSSTransitionGroup
      transitionName="add_vehicle"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
    >
      {fields.map((vehicle, index) => (
        <div key={index} className="row">
          <div className="cotenantHeader" style={{ padding: '0 15px', marginBottom: '-10px' }}>
            <h4 style={{ lineHeight: '26px' }}>
              {getTranslatedString('tenantPortal.application.vehicles.list')}
              {index + 1}
              <IconButton
                style={{
                  padding: 0,
                  verticalAlign: 'text-bottom',
                  width: 'none',
                  height: 'none',
                  float: 'right',
                }}
                onClick={() => fields.remove(index)}
              >
                <DeleteIcon size={24} style={{ padding: 0 }} />
              </IconButton>
            </h4>
          </div>

          <div className="row" style={{ marginBottom: '10px' }}>
            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <Field
                name={`${vehicle}.make`}
                type="text"
                component={TextField}
                floatingLabelText={getTranslatedString(
                  'tenantPortal.application.vehicles.make/type'
                )}
                style={{ marginTop: '-15px', fontSize: '14px' }}
                errorStyle={{ fontSize: '14px' }}
              />
              <Field name={`${vehicle}.make`} component={RenderGhostError} />
            </div>
            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <Field
                name={`${vehicle}.vehicle_type`}
                type="text"
                component={SelectField}
                floatingLabelText={getTranslatedString('tenantPortal.application.vehicles.type')}
                style={{ marginTop: '-15px', fontSize: '14px', textAlign: 'initial' }}
                errorStyle={{ fontSize: '14px' }}
              >
                {VEHICLE_TYPES.map((type) => (
                  <MenuItem value={type.value} primaryText={type.primaryText} />
                ))}
              </Field>
              <Field name={`${vehicle}.vehicle_type`} component={RenderGhostError} />
            </div>
            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <Field
                name={`${vehicle}.color`}
                type="text"
                component={TextField}
                floatingLabelText={getTranslatedString('tenantPortal.application.vehicles.color')}
                style={{ marginTop: '-15px', fontSize: '14px' }}
                errorStyle={{ fontSize: '14px' }}
              />
              <Field name={`${vehicle}.color`} component={RenderGhostError} />
            </div>
            <div className="col-sm-6" style={{ textAlign: 'center' }}>
              <Field
                name={`${vehicle}.vehicle_plate_number`}
                type="text"
                component={TextField}
                floatingLabelText={getTranslatedString('tenantPortal.application.vehicles.plate')}
                style={{ marginTop: '-15px', fontSize: '14px' }}
                errorStyle={{ fontSize: '14px' }}
              />
              <Field name={`${vehicle}.vehicle_plate_number`} component={RenderGhostError} />
            </div>
          </div>
        </div>
      ))}
    </CSSTransitionGroup>
    <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
      <FlatButton
        label={getTranslatedString('tenantPortal.application.vehicles.button.add')}
        type="button"
        backgroundColor={AccentColor()}
        hoverColor="grey"
        style={style.add_vehicle_button}
        onClick={() => {
          fields.push();
          setTimeout(
            () =>
              document
                .getElementById('button')
                .scrollIntoView({ block: 'end', behaviour: 'smooth' }),
            0
          );
        }}
      />

      {error && (
        <p
          style={{
            marginTop: '10px',
            fontSize: '11px',
            color: AccentColor(),
          }}
          id="errorMessage"
        >
          {error}
        </p>
      )}
    </div>
  </div>
);

let WizardFormVehiclePage = class extends React.Component {
  render() {
    const { handleSubmit, previousPage, showVehiclesForm, hideVehiclesForm } = this.props;

    return (
      <div id="top" style={{ marginTop: '50px' }}>
        <h3
          style={{
            fontSize: '30px',
            marginBottom: '20px',
            fontFamily: 'Circular-Bold',
          }}
        >
          {getTranslatedString('tenantPortal.application.vehicles.prompt')}{' '}
          <i className="em em-oncoming_automobile" />
        </h3>
        <div className="row" style={{ textAlign: 'center' }}>
          <Field name="has_vehicle" component={RadioButtonGroup}>
            <RadioButton
              value="Yes"
              label={getTranslatedString('tenantPortal.application.vehicles.button.yes')}
              onClick={showVehiclesForm}
              style={{ width: '85px', display: 'inline-flex', fontSize: '18px' }}
            />
            <RadioButton
              value="No"
              label={getTranslatedString('tenantPortal.application.vehicles.button.no')}
              onClick={hideVehiclesForm}
              style={{ width: '85px', display: 'inline-flex', fontSize: '18px' }}
            />
          </Field>
          <Field name="has_vehicle" component={RenderError} />
        </div>

        <form onSubmit={handleSubmit}>
          <CSSTransitionGroup
            transitionName="fade_out_buttons"
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
          >
            {this.props.showVehicles && <FieldArray name="vehicles" component={renderVehicles} />}
          </CSSTransitionGroup>
          <div id="button" style={{ marginBottom: '75px' }} />
          <div id="application_footerbar">
            <div style={{ textAlign: 'center', maxWidth: '600px', margin: 'auto' }}>
              <FlatButton
                label={getTranslatedString('tenantPortal.application.vehicles.button.back')}
                type="button"
                className="previous"
                onClick={previousPage}
                backgroundColor={colors.WHITE}
                hoverColor="grey"
                style={style.backButton}
              />
              <FlatButton
                label={getTranslatedString('tenantPortal.application.vehicles.button.next')}
                type="submit"
                className="next"
                primary={true}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                style={style.button}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
};

WizardFormVehiclePage = reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmitFail: (errors) => {
    scrollIntoView(document.getElementById('errorMessage'), {
      time: 500,
      align: {
        top: 0.25,
      },
    });
  },
})(WizardFormVehiclePage);

WizardFormVehiclePage = connect((state) => ({
  showVehicles: state.tenantApplication.showVehiclesForm,
}))(WizardFormVehiclePage);

export default WizardFormVehiclePage;
